import * as roleApi from "@hub/management/src/modules/roles/api/roles.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const listRoles = async params => {
  try {
    return await roleApi.listRoles(params)
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Erro ao buscar perfis"
    })
  }
}

export const listActiveRoles = async params => {
  try {
    const { data: roles } = await roleApi.listActiveRoles(params)
    return roles
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Erro ao buscar perfis ativos."
    })
  }
}

export const listPermissions = async params => {
  try {
    const { data: contentData } = await roleApi.listPermissions(params)
    return contentData.permissions
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Erro ao obter permissões."
    })
  }
}

export const listReportPermissions = async params => {
  try {
    const { data: contentData } = await roleApi.listReportPermissions(params)
    return contentData.report_permissions
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Erro ao obter permissões."
    })
    throw error
  }
}

export const listMenuPermissions = async params => {
  try {
    const { data: contentData } = await roleApi.listMenuPermissions(params)
    return contentData.sidebar_menus
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Erro ao obter permissões de menu."
    })
  }
}

export const listHomePermissions = async params => {
  try {
    const { data: contentData } = await roleApi.listHomePermissions(params)
    return contentData.home_menus
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Erro ao obter permissões de home."
    })
  }
}

export const listCategories = async params => {
  try {
    const { data } = await roleApi.listCategories(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() || "Erro ao buscar categorias"
    })
  }
}

export const fetchRole = async uuid => {
  try {
    const { data } = await roleApi.fetchRole(uuid)
    return data.role
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Erro ao obter perfil."
    })
  }
}

export const changeStatusRole = async (data, uuid) => {
  try {
    const response = await roleApi.changeStatusRole(data, uuid)
    window.$vue.$toast({
      type: "success",
      title: "Status do perfil alterado com sucesso!"
    })
    return response
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao alterar status do perfil."
    })
  }
}

export const createRole = async data => {
  try {
    await roleApi.createRole(data)

    await window.$vue.$router.push({ name: "role-list" })

    window.$vue.$toast({
      type: "success",
      title: "Perfil cadastrado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        createRoleErrorMessage("cadastrar", error)
    })
  }
}

export const editRole = async (data, uuid) => {
  try {
    await roleApi.editRole(data, uuid)

    await window.$vue.$router.push({ name: "role-list" })

    window.$vue.$toast({
      type: "success",
      title: "Perfil editado com sucesso."
    })
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        createRoleErrorMessage("editar", error)
    })
  }
}

function createRoleErrorMessage(verb, error) {
  if (error?.response?.data?.field == "permissions") {
    return "Por favor, escolha alguma permissão"
  }
  return `Falha ao ${verb} perfil.`
}

export const duplicateRole = async uuid => {
  try {
    const response = await roleApi.duplicateRole(uuid)
    window.$vue.$toast({
      type: "success",
      title: "Perfil duplicado com sucesso!"
    })
    return response
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao duplicar perfil."
    })
  }
}

export const getAllRoles = async () => {
  try {
    const { data } = await roleApi.getAllRoles()
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Erro ao buscar perfis"
    })
  }
}
